// extracted by mini-css-extract-plugin
export default {"postsContainer":"Posts_postsContainer__p2s8i","qrCode":"Posts_qrCode__yu6Om","text":"Posts_text__9CstI"};